import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

/**
 * Servizio Window / Viewport
 * Detiene le dimensioni del viewport, il flag hideMenu e il wiring dei
 * listener window (resize/orientationchange).
 * Estratto dal god-controller application (maintainability 4.2, gruppo G),
 * comportamento invariato; il controller mantiene una façade getter/setter.
 */
let WindowViewportService = (_class = class WindowViewportService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "windowsHeight", _descriptor, this);
    _initializerDefineProperty(this, "windowsWidth", _descriptor2, this);
    _initializerDefineProperty(this, "bodyFontSize", _descriptor3, this);
    // Writable one-way alias of `isSmallDevice` (was `reads('isSmallDevice')`).
    // The override is tracked so `hideMenu = ...` keeps reacting.
    _initializerDefineProperty(this, "_hideMenu", _descriptor4, this);
    // Stored handler refs so teardownWindowListeners can removeEventListener
    // with the same function reference used in setupWindowListeners.
    this._resizeHandler = null;
    this._orientationChangeHandler = null;
  }
  get isSmallDevice() {
    if (typeof window.matchMedia === 'function') {
      return !window.matchMedia('(min-width: 40rem)').matches;
    }
    return this.windowsWidth / parseFloat(this.bodyFontSize) < 40;
  }
  get hideMenu() {
    return this._hideMenu !== undefined ? this._hideMenu : this.isSmallDevice;
  }
  set hideMenu(value) {
    this._hideMenu = value;
  }

  /**
   * Configura i listener per eventi window
   */
  setupWindowListeners() {
    this._resizeHandler = () => this.handleResizeWindows();
    this._orientationChangeHandler = () => this.handleRotateWindows();
    window.addEventListener('resize', this._resizeHandler);
    window.addEventListener('orientationchange', this._orientationChangeHandler);
    this.handleRotateWindows();
  }

  /**
   * Rimuove i listener window (da chiamare in willDestroy)
   */
  teardownWindowListeners() {
    if (this._resizeHandler) {
      window.removeEventListener('resize', this._resizeHandler);
    }
    if (this._orientationChangeHandler) {
      window.removeEventListener('orientationchange', this._orientationChangeHandler);
    }
  }

  /**
   * bind on windows size
   */
  /* istanbul ignore next -- device viewport resize listener reading real window dimensions (§11.4) */
  handleResizeWindows() {
    this.windowsHeight = window.innerHeight;
    this.windowsWidth = window.innerWidth;
  }

  /**
   * Handle rotationevent is triggered
   * when the user rotates the mobile device
   * vertically or horizontally
   */
  /* istanbul ignore next -- device orientation listener reading window.orientation (§11.4) */
  handleRotateWindows() {
    const html = document.documentElement.classList;
    if (window.orientation === 0) {
      html.remove('landscape');
      html.add('portrait');
    } else {
      html.remove('portrait');
      html.add('landscape');
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "windowsHeight", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return window.innerHeight;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "windowsWidth", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return window.innerWidth;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bodyFontSize", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return getComputedStyle(document.body).fontSize;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_hideMenu", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { WindowViewportService as default };
//# sourceMappingURL=window-viewport.js.map
